/**************************************************
 * Nombre:       Home_Pasarela_Safari
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, IconButton, Typography} from "@mui/material";
import {ResponsiveContainer, StackedCarousel,} from "react-stacked-center-carousel";
import {memo, useContext, useEffect, useRef, useState} from "react";
import {ArrowRightAlt, KeyboardArrowRight} from '@mui/icons-material'
import Tarjeta_Producto from "../../Tarjetas/Tarjeta_Producto";
import {theme} from "../../../Tema";
import {useNavigate} from "react-router";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {contexApp} from "../../../App";
import {obtenerColWheres} from "../../../Servicios/BD/obtenerColWheres";
import {where} from "firebase/firestore";

const Home_Pasarela_Safari = () => {
    const {sCell, masSM, sTab, esSafari, esIPhone} = useResponsive()
    const ref = useRef();
    const navigate = useNavigate()
    const cData = useContext(contexApp)
    const [imgs, setImgs] = useState([])
    const [frente, setFrente] = useState(1)
    const [productos, setProductos] = useState([])
    const [prodsModelo, setProdsModelo] = useState([])


    const Card = memo(function (props) {
        const {data, dataIndex} = props;
        const {cover} = data[dataIndex];

        return (
            <div
                style={{
                    height: !masSM ? 450 : 600,
                    userSelect: "none",
                    transform: 'scaleX(-1)',
                    justifyContent: 'flex-end'
                }}
                className="my-slide-component"
            >
                <img
                    style={{
                        height: "100%",
                        width: esIPhone() ? '52%' : sCell ? "100%" : "68%",
                        objectFit: "fill",
                        borderRadius: 0,
                        opacity: frente === (dataIndex) ? 1 : frente === (dataIndex + 1) ? 0.8 : frente === (dataIndex + 2) ? 0.7 : 0.5,
                        filter: frente === dataIndex ? `blur(0px)` : frente === (dataIndex + 1) ? `blur(1px)` : frente === (dataIndex + 2) ? `blur(2px)` : `blur(4px)`
                    }}
                    draggable={false}
                    src={cover}
                />
            </div>
        );
    });

    const siguiente = () => {
        if (ref.current) {
            ref.current.goBack()
        }

    }


    useEffect(() => {


        if (imgs[frente]) {
            let img = imgs[frente].cover
            setProdsModelo([])
            let arr = []
            for (let i = 0; i < productos.length; i++) {
                let prod = productos[i]
                if (prod.modelos && prod.modelos.includes(img)) {
                    arr.push(prod)
                }

            }

            setProdsModelo(arr)
        }


    }, [frente]);

    useEffect(() => {

        if (cData.actColeccion && cData.actColeccion.id) {
            let arr = cData.actColeccion.imgs

            if (arr) {
                let arrObj = arr.map((it) => {
                        return {cover: it, title: ''}
                    }
                )
                setImgs(arrObj)
            }

            let idCol = cData.actColeccion.id
            let wp = [where('idColeccion', '==', idCol), where('estado', '==', 'Publicado')]
            obtenerColWheres({col: 'productos', wheres: wp}).then((dox) => {

                setProductos(dox.data)
            })

        }

    }, [cData]);

    useEffect(() => {

        if (ref.current) {
            setTimeout(() => {
                siguiente()
            }, 1000)

        }

    }, [ref.current])
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
        >

            {cData.actColeccion.imgs && cData.actColeccion.imgs.length > 0 &&

                <Grid
                    container
                    justifyContent={'flex-end'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{maxWidth: '1400px', px: sCell ? 2 : 6}}
                >

                    <Grid container size={{xs: 12, sm: 6, md: 4}}>
                        <Typography
                            sx={{
                                color: theme.palette.primary.main,
                                fontSize: 14,
                                textAlign: sCell ? 'center' : 'left'
                            }}>
                            {/*cData?.actColeccion?.descripcion*/}
                        </Typography>
                    </Grid>

                    <Grid container size={{xs: 0, sm: 6, md: 8}}>

                    </Grid>

                    <Grid container size={{xs: 12, sm: 7, md: 12}} sx={{
                        pr: sCell && !esSafari() ? 0 : 8,
                        zIndex: 1,
                        mt: sCell ? 4 : 0,
                        ml: esIPhone() ? -24 : 0,
                        mr: esIPhone ? 24 : 0

                    }}
                    >

                        {imgs.length > 0 &&
                            <ResponsiveContainer
                                carouselRef={ref}
                                render={(parentWidth, carouselRef) => {
                                    let currentVisibleSlide = !masSM ? 5 : 7;
                                    // if (parentWidth <= 1440) currentVisibleSlide = 9;
                                    // if (parentWidth <= 1080) currentVisibleSlide = 1;
                                    return (
                                        <StackedCarousel
                                            ref={carouselRef}
                                            slideComponent={Card}
                                            slideWidth={500}
                                            carouselWidth={sCell ? 800 : parentWidth}
                                            data={imgs}
                                            currentVisibleSlide={currentVisibleSlide}
                                            maxVisibleSlide={currentVisibleSlide}
                                            useGrabCursor
                                            fadeDistance={0}
                                            onActiveSlideChange={(e) => setFrente(e)}
                                            // customScales={[1, 1, 1, 1,1]}
                                        />
                                    );
                                }}
                            />
                        }

                    </Grid>


                    <Grid container size={{xs: 12, sm: 12, md: 4}}
                          sx={{
                              justifyContent: 'flex-end',
                              zIndex: 2,
                              background: 'linear-gradient(270deg, #FFF 75.92%, rgba(255, 237, 237, 0.00) 99.91%)',
                              p: sCell ? 2 : 6,
                              borderRadius: 4,
                              mt: sCell ? 6 : -75,
                              height: sCell ? 'auto' : 600,
                              ml: sCell ? 0 : -6,
                              mr: sCell ? 0 : 6,
                              pl: sCell ? 2 : 0,
                              width: '110%'
                          }}
                          alignItems={'center'}
                    >


                        {masSM &&
                            <Grid container size={{xs: 12, sm: 12, md: 2}}>
                                <IconButton
                                    onClick={() => siguiente()}
                                    sx={{backgroundColor: '#796254', '&:hover': {backgroundColor: '#5c4a40'}}}>
                                    <KeyboardArrowRight sx={{fill: '#fff'}}/>
                                </IconButton>
                            </Grid>
                        }

                        <Grid
                            container
                            justifyContent={'flex-end'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 10}}
                            spacing={3}

                        >

                            {prodsModelo.map((it, index) => {
                                return (
                                    <Grid container size={{xs: 6, sm: 6, md: 6}}>
                                        <Tarjeta_Producto item={it}/>
                                    </Grid>
                                )
                            })}

                        </Grid>
                    </Grid>


                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                          sx={{mt: sCell ? 6 : 1, ml: sCell ? 0 : -2, justifyContent: sCell ? 'center' : 'left'}}>
                        <Button
                            onClick={() => navigate('/DetalleCol/' + cData.actColeccion.id)}
                            variant={sCell ? 'contained' : 'text'} endIcon={<ArrowRightAlt/>}
                            sx={{px: sCell ? 4 : 2}}
                        >Ver toda la colección</Button>
                    </Grid>

                </Grid>
            }

        </Grid>
    )

}
export default Home_Pasarela_Safari



